export const httpManager = function ($http) {
   return { 
   		postRequester: function (requestMethod,parameters,secure,successCallback,errorCallback) {
            // var webUrl = process.env.NODE_ENV == 'production' ? 'https://zantyes.com/' : 'https://localhost/zantyes/';
			// var webUrl = 'https://zantyes.com/';

			var headers = {'Content-Type': 'application/json','accept': 'application/json, text/javascript, */*; q=0.01'};

			if( errorCallback == null){
				errorCallback = function (response) {
					switch( response.status){
						case 401 :
							var storage = window.localStorage;
							break;
					}
				};
			}
    		$http({method: 'POST',url: requestMethod,data: parameters,headers: headers}).then( successCallback, errorCallback );
		},
		getRequester: function (requestMethod,parameters,secure,successCallback,errorCallback) {

			var headers = {'accept': 'application/json, text/javascript, */*; q=0.01'};

			if( errorCallback == null){
				errorCallback = function (response) {
					switch( response.status){
						case 401 :
							var storage = window.localStorage;
							// storage.removeItem('token');
							// $state.go('login',{});
							break;
					}
					// loadManager.hideWaiter();
				};
			}
    		$http({method: 'GET',url: requestMethod,data: parameters,headers: headers}).then( successCallback, errorCallback );
		}
		// 
		,jsonParser: function (response) {
    		var x2js = new X2JS();
    		return x2js.xml_str2json(response.data);
		},
		jsonCleaner: function (response) {
			return response.string.__text.replace(/\r?\n|\r/g,'');
		}
   };
};

// ,getRequester: function (requestMethod,parameters,secure,successCallback,errorCallback) {
// 	var webUrl = 'https://api.dctp.club/web/';
// 	var storage = window.localStorage;
// 	var headers = {'Content-Type': 'application/json'};
	
// 	if(secure){
// 		headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + storage.getItem('token')};
// 	}			
// 	if( errorCallback == null){
// 		errorCallback = function (response) {
// 			switch( response.status){
// 				case 401 :
// 					var storage = window.localStorage;
// 					storage.removeItem('token');
// 					$state.go('login',{});
// 					break;
// 			}
// 			loadManager.hideWaiter();
// 		};
// 	}

// 	$http({method: 'GET',url: webUrl+requestMethod,data: parameters,headers: headers}).then( successCallback, errorCallback );
// },